import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Account } from './account.model';
import { AccountService } from './account.service';

export const userAccountResolver: ResolveFn<Account> = (route, state) => {
  const accountService: AccountService = inject(AccountService);
  return accountService.fetch();
};
